import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Role, Permission } from '../../../models/access.model';
import { PermissionService } from '../../../services/permission.service';
import { UserRoleService } from '../../../services/user-role.service';

@Component({
  selector: 'app-roles-page',
  standalone: false,
  templateUrl: './roles-page.component.html',   // <-- match your actual file names
  styleUrls: ['./roles-page.component.css'],   // or .css if you used CSS
})
export class RolesPageComponent implements OnInit {
  
  roles: Role[]= [];
  filteredRoles: Role[] = [];
  permissions: Permission[] = [];
  selectedRole: Role | null = null;
  isLoading = false;
  searchTerm = '';
  filterMode: 'all' | 'system' | 'business' = 'all';

  constructor(private userRoleService: UserRoleService,
    private permissionService: PermissionService, private router: Router) {}

  ngOnInit(): void {
    this.loadData();
  }

  private loadData(): void {
    this.isLoading = true;

    Promise.all([
      this.userRoleService.getRoles().toPromise(),
      this.permissionService.getPermissions().toPromise(),
    ])
      .then(([roles, permissions]) => {
        const incoming = roles ?? [];
        this.roles = incoming.map((r: any) => (r?.roleId ? r : { ...r, roleId: r?.id })) as Role[];
        this.filteredRoles = [...this.roles];
        this.permissions = permissions ?? [];

        // if (this.roles.length > 0) {
        //   this.onSelectRole(this.roles[0]);
        // }
      })
      .finally(() => (this.isLoading = false));
  }

  onSearch(term: string): void {
    this.searchTerm = term;
    this.applyFilters();
  }

  setFilterMode(mode: 'all' | 'system' | 'business'): void {
    this.filterMode = mode;
    this.applyFilters();
  }

  private applyFilters(): void {
    const lower = (this.searchTerm || '').toLowerCase();
    this.filteredRoles = this.roles.filter(r => {
      const matchesSearch =
        r.roleName.toLowerCase().includes(lower) ||
        (!!r.displayName && r.displayName.toLowerCase().includes(lower));
      const isSystem = !!r.isSystemLevel;
      const matchesType =
        this.filterMode === 'system' ? isSystem :
        this.filterMode === 'business' ? !isSystem :
        true;
      return matchesSearch && matchesType;
    });
  }

  onSelectRole(role: Role): void {
    this.selectedRole = role;
  }

  onRoleUpdated(updated: Role): void {
    const index = this.roles.findIndex(r => r.roleId === updated.roleId);
    if (index >= 0) {
      this.roles[index] = updated;
    }
    this.applyFilters(); // re-apply filters
  }
}
